import Layout from './layout';
import headerImage from '../content/tennis.jpeg';
import HeroImage from '../components/HeroImage';

export default function Contact() {
  return (
  <Layout>
      <HeroImage title='' headerImage={headerImage}/>

      {/* Text Section */}
      <section className="flex-grow px-4 font-gordita  py-10 bg-pink text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4">Get in touch</h2>
        <p className="text-gray-600 text-base sm:text-lg max-w-3xl mx-auto">
        If you'd like to get in touch to attend an event, ask a question or propose a new event, you can do so by emailing Danni at <a href="mailto:info@girlsclubteesside.co.uk" className='underline hover:text-cosmopink'>info@girlsclubteesside.co.uk</a> or dropping a message through on <a href="https://www.instagram.com/girls_club_teesside/" target='_blank' rel="noreferrer" className='underline hover:text-cosmopink'>Instagram</a>.
        {/* <br/>
        <br/>
        To hear about events first, join our  <a href="/mailing" className='underline hover:text-cosmopink'>mailing list!</a> */}
        </p>
      </section>
  </Layout>
  );
}
